import { render, staticRenderFns } from "./NewsDetail2.vue?vue&type=template&id=60b7bdfc&scoped=true"
var script = {}
import style0 from "./NewsDetail2.vue?vue&type=style&index=0&id=60b7bdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7bdfc",
  null
  
)

export default component.exports